import React, { useState } from "react";
import * as S from "./styles";

export default function ModalLGPD() {
  const [openModal, setOpenModal] = useState(() => sessionStorage.getItem("lgpdAccepted") !== "true");

  const handleAccept = () => {
    sessionStorage.setItem("lgpdAccepted", "true");
    setOpenModal(false);
  };

  if (!openModal) {
    return null;
  }

  return (
    <>
      <S.Modal>
        <S.ContentModal>
          <S.Title>Sua privacidade é importante pra gente!</S.Title>
          <S.Text>
            Ao clicar em "Aceitar", você concorda com o armazenamento de cookies
            no seu dispositivo para melhorar a sua experiência no site.
          </S.Text>

          <S.Button onClick={handleAccept}>Aceitar</S.Button>

          <S.Links>
            <a href="https://www.johnsonsbaby.com.br/politica-de-privacidade" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
            <div>|</div>
            <a href="https://www.johnsonsbaby.com.br/politica-de-cookies" target="_blank" rel="noopener noreferrer">Política de Cookies</a>
          </S.Links>
        </S.ContentModal>
      </S.Modal>
      <S.ModalOverlay />
    </>
  );
}
